module.exports = __webpack_public_path__ + "img/empty.f090cc62.png";